@if (!iso) {
<empty>-</empty>
} @if (iso) {
<time [attr.datetime]="iso">
  {{ iso | date : 'HH:mm:ss' : 'UTC' }}
  {{ rfc | date : 'H:i:s' : 'UTC' }}
</time>
}
